<div class="app-filter-wrapper" (clickOutside)="closeDropdown()">
  <!-- Filter Trigger Pill -->
  <div class="app-filter-pill" [class.app-filter-pill--active]="isFilterApplied" [class.app-filter-pill--open]="isOpen"
    [class.app-filter-pill--disabled]="disabled" (click)="toggleDropdown($event)">
    <!-- Plus / Cross Icon -->
    <span class="app-filter-pill__icon" [class.app-filter-pill__icon--active]="isFilterApplied"
      (click)="isFilterApplied && handleCancelFilter($event)">
      <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.8" />
        <path d="M10 5.5V14.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
        <path d="M5.5 10H14.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      </svg>
    </span>

    <!-- Label -->
    <span class="app-filter-pill__label">
      {{ resolvedLabel }}
      <span *ngIf="isFilterApplied" class="app-filter-pill__value">
        | {{ displaySelectedLabel }}
      </span>
    </span>
  </div>

  <!-- Popover Menu -->
  <div *ngIf="isOpen" class="app-filter-popover" (click)="$event.stopPropagation()">
    <div class="app-filter-popover__header">
      <p class="app-filter-popover__title">Filter by {{ labelText }}</p>
    </div>

    <!-- Search in options -->
    <div *ngIf="searchable" class="app-filter-popover__search">
      <input type="text" [(ngModel)]="searchText" [placeholder]="searchPlaceholder"
        class="app-filter-popover__search-input" />
    </div>

    <!-- Options List -->
    <div class="app-filter-popover__options">
      <div *ngFor="let opt of filteredOptions" class="app-filter-popover__option"
        [class.app-filter-popover__option--selected]="isSelected(opt.value)"
        (click)="selectOption(opt.value)">
        <span *ngIf="!multiple" class="app-filter-popover__option-radio">
          <span *ngIf="isSelected(opt.value)" class="app-filter-popover__option-radio-dot"></span>
        </span>
        <span *ngIf="multiple" class="app-filter-popover__option-checkbox" [class.app-filter-popover__option-checkbox--checked]="isSelected(opt.value)">
          <svg *ngIf="isSelected(opt.value)" width="10" height="10" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.5 4.5L6.5 11.5L3 8" stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <span class="app-filter-popover__option-text">{{ opt.label }}</span>
      </div>

      <div *ngIf="filteredOptions.length === 0" class="app-filter-popover__empty">
        No options found
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="app-filter-popover__actions">
      <app-primary-button label="APPLY" size="medium" [fullWidth]="true" (btnClick)="applyFilter($event)"
        [disabled]="isApplyDisabled"></app-primary-button>
    </div>
  </div>
</div>